import superagent from 'superagent'
import axios from 'axios';

const csrfTag = (doc=document) => _.first(doc.querySelectorAll('meta[name="csrf-token"]'));
export const csrfToken = () => csrfTag()?.content;

export const submitListingAction = (listing, action, status_reason, callback) => {
  const {id} = listing;
  const initialStatus = _.pick(listing, ['id', 'status', 'status_reason', 'status_changed_at']);
  const newStatus = {id, status: action, status_reason, status_changed_at: new Date()};
  const msgData = action == "undo" ? initialStatus : newStatus;

  superagent.patch(`/listings/${id}`)
    .set({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken()
    }).responseType('json')
    .send({listing: msgData})
    .end(callback)
};

export function getAxios() {
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': csrfToken()
  };
  const api = axios.create({headers});
  api.interceptors.response.use(function onFulfilled(response) {
    return response;
  }, function onRejected(error) {
    if (error.response.status == 401) {
      return window.location.reload();
    }
    return Promise.reject(error);
  })
  return api;
}

export function refreshHeader() {
  return axios.get("/", {headers: {'X-CSRF-Token': csrfToken()}})
    .then(({data}) => new DOMParser().parseFromString(data, "text/html"))
    .then((page) => {
      csrfTag(document).content = csrfTag(page)?.content;
      document.querySelector("body > header").innerHTML = page.querySelector("body > header").innerHTML;
    });
}

export function signInAdopter({email, password}) {
  return getAxios().post('/adopters/sign_in', {adopter: {email, password}})
    .then((response) => response.data);
}

export function signUpAdopter({email, password, passwordConfirm: password_confirmation, subscribe}) {
  return getAxios().post('/adopters', {adopter: {email, password, password_confirmation, subscribe}})
    .then((response) => response.data);
}

export function searchListings(terms) {
  return getAxios().post('/search', {terms})
    .then((response) => response.data);
}

export function contributorSearchListings({search, view_scope}) {
  return getAxios().post('/contributor_search', {search, view_scope})
    .then((response) => response.data);
}

export function addFavorite(id) {
  return getAxios().post(`/api/v1/listings/${id}/favorite`, {})
    .then((response) => response.status)
    .catch((error) => console.warn(error));
}

export function deleteFavorite(id) {
  return getAxios().delete(`/api/v1/listings/${id}/favorite`)
    .then((response) => response.status)
    .catch((error) => console.warn(error));
}

export function subscribeSearch(search, notification_opt_in_at) {
  return getAxios().post('/api/v1/search_notifications', {search, notification_opt_in_at});
}

export function unsubscribeSearch(search_notification_id) {
  return getAxios().delete(`/api/v1/search_notifications/${search_notification_id}`);
}

export function updateSearchNotification(search_notification_id, {name}) {
  return getAxios().patch(`/api/v1/search_notifications/${search_notification_id}`, {search_notification: {name}});
}

export function updateListing(id, params) {
  return getAxios().patch(`/listings/${id}`, {listing: {id, ...params}});
}

export function uploadAttachments(key, id, files) {
  const formData = new FormData();
  files.forEach((file) => formData.append(`listing[${key}][]`, file));
  formData.append('listing[id]', id);
  return getAxios().post(`/upload.json`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
}

export function deleteListingMedium(id) {
  return getAxios().delete(`/listing_media/${id}`)
}

export function deleteListingDocument(id) {
  return getAxios().delete(`/listing_documents/${id}`)
}

export function updateImageOrder(id, order) {
  return getAxios().post(`/media_order/${id}`, {media_order: order});
}

export function uploadImageCropping(id, {width, height, x, y}) {
  return getAxios().patch(`/listing_media/${id}`, {
    listing_medium: {crop_width: width, crop_height: height, crop_x: x, crop_y: y}
  });
}

export function importCSV(file, mapping) {
  const formData = new FormData();
  formData.append('csv_upload[carrierwave_file]', file);
  if (mapping) formData.append('csv_upload[mapping]', JSON.stringify(mapping));
  return getAxios().post(`/csv_uploads.json`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
}

export function exportCSV(mapping, filters) {
  return getAxios().post(`/csv_exports`, {csv_export: {mapping, filters}});
}

export function createHelpRequest(csv_upload_id) {
  return getAxios().post(`/csv_uploads/${csv_upload_id}/help_requests`)
}

export function createAPIKey() {
  return getAxios().post('/api_keys');
}

export function loadAnalytics(organization_id, from, to) {
  return getAxios().get('/analytics', {params: {organization_id, from, to}});
}

export function createAnalyticsPDF(markup) {
  return getAxios().post('/analytics_pdfs', {markup});
}
